 
 
 

import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../redux/initialStoreState";
import { useDispatchWrapper, useQueryParms } from "../../../../../hooks";
import { PageLoader } from "../../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../../constants/enums";
import { StandadCard } from "../../../../../components/Cards";
import {
  AccountCircle,
  AdminPanelSettings,
} from "@mui/icons-material";
import { TabPanel } from "../../../../../components/Tabs/TabPanel";
import { useNavigate, useOutletContext } from "react-router-dom";
import { fetchCommAutomobileCustomerInfoAsync } from "../../../../../redux/commAutoPolicy/commAutoBasicDetails/commAutoBasicDetailsActions";
import { Tab, Tabs } from "@mui/material";
import { a11yProps } from "../../../../../components/Tabs/utils";
import { AutomobileCSIOApplicationList } from "./AutomobileCSIOApplicationForm/AutomobileCSIOApplicationList";
import { AutomobileCSIOPolicyEndorsementList } from "./AutomobileCSIOApplicationForm/AutomobileCSIOPolicyChangeEndorsement/AutomobileCSIOPolicyChangeEndorsement";
import { AutomobileCSIOEDIApplicationList } from "./AutomobileCSIOEDIApplication/AutomobileCSIOEDIApplicationList";

export const AutomobileCSIOApplicationTab = () => {
  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];
  const { getParm } = useQueryParms();
  const tabValue = getParm("tab");
  const selectedTab = tabValue ? Number(tabValue) : 0;
  const { customerInfo } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.basicDetails
  );

  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();

  const handleChangetab = (event: React.SyntheticEvent, newValue: number) => {
    navigate(
      `/automobile-policy/${customerId}/automobile-csio-application-tab/${customerPolicyId}?tab=${newValue}`
    );
  };

  React.useEffect(() => {
    if (customerPolicyId) {
      //   dispatch(fetchBindersListAsync(customerPolicyId));
      dispatch(fetchCommAutomobileCustomerInfoAsync(customerPolicyId));
    }
  }, [customerPolicyId]);

  return (
    <PageLoader loading={customerInfo.loading === LoadState.InProgress}>
      <StandadCard sx={{ marginBottom: 2 }}>
        <Tabs
          value={selectedTab}
          variant="fullWidth"
          scrollButtons="auto"
          onChange={handleChangetab}
        >
          <Tab
            icon={<AccountCircle />}
            iconPosition="start"
            label="CSIO Application"
            {...a11yProps(0)}
          />
          <Tab
            sx={{ minHeight: "50px" }}
            icon={<AdminPanelSettings />}
            iconPosition="start"
            label="Policy Change/Endorsement"
            {...a11yProps(1)}
          />
          <Tab
            sx={{ minHeight: "50px" }}
            icon={<AdminPanelSettings />}
            iconPosition="start"
            label="EDI"
            {...a11yProps(2)}
          />
        </Tabs>
      </StandadCard>
      {/* <Divider /> */}
      <TabPanel value={selectedTab} index={0}>
        <AutomobileCSIOApplicationList />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <AutomobileCSIOPolicyEndorsementList />
      </TabPanel>
      <TabPanel value={selectedTab} index={2}>
        <AutomobileCSIOEDIApplicationList
         />
      </TabPanel>
    </PageLoader>
  );
};
